module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-bar-container"
  }, [_vm._v("\n\t 头\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d9799bb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/components/VabNavBar/index.vue
// module id = 883
// module chunks = 1